import { render, staticRenderFns } from "./marketData.vue?vue&type=template&id=9012334c&scoped=true"
import script from "./marketData.vue?vue&type=script&lang=js"
export * from "./marketData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9012334c",
  null
  
)

export default component.exports